import React from "react";
import { connect } from "react-redux";
import Markers from "./Markers";

function MarkersGroup({
  mapRef,
  services,
  solution,
  warnClick,
  hiddenRoutes,
  visibleRoutes,
  markersHidden,
  expandedRoutes,
  emptyRoutesVisible,
  unscheduledMarkersHidden,
  fullRoutes
}) {
  return solution && solution.status !== "ERROR" ? (
    <>
      {!markersHidden &&
        fullRoutes.map((route, i) => {
          return (
            !hiddenRoutes.includes(route.id) &&
            (emptyRoutesVisible ||
              route.stops.some(
                task =>
                  task.type !== "start" &&
                  task.type !== "end" &&
                  task.type !== "break" &&
                  task.type !== "reload"
              )) &&
            visibleRoutes.includes(route.id) && (
              <Markers
                endLocationDefined={route.end_location_defined}
                key={route.id}
                markers={route.stops}
                routeIndex={i}
                mapRef={mapRef}
                routeStatus={route.status}
                routeId={route.id}
                index={route.index}
                isRouteExpanded={false}
                warnClick={warnClick}
              />
            )
          );
        })}

      {/* Unassigned services */}
      {!unscheduledMarkersHidden && (
        <Markers
          key={-1}
          markers={solution.unassigned.stops}
          routeIndex={-1}
          mapRef={mapRef}
          warnClick={warnClick}
        />
      )}
    </>
  ) : (
    !unscheduledMarkersHidden && (
      <Markers markers={services} warnClick={warnClick} mapRef={mapRef} />
    )
  );
}

const mapStateToProps = state => ({
  solution: state.project.solution,
  services: state.project.vrp.stops,
  hiddenRoutes: state.map.hiddenRoutes,
  markersHidden: state.map.markersHidden,
  unscheduledMarkersHidden: state.map.unscheduledMarkersHidden,
  expandedRoutes: state.common.expandedRoutes,
  emptyRoutesVisible: state.common.emptyRoutesVisible
});

export default connect(mapStateToProps, {})(MarkersGroup);
